"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getTransactions = void 0;
var network_1 = __importDefault(require("../../../network"));
var types_1 = require("../types");
var env_1 = require("../../../env");
var logic_1 = require("../logic");
var range_1 = __importDefault(require("lodash/range"));
var chunk_1 = __importDefault(require("lodash/chunk"));
var constants_1 = require("../constants");
function fetchTransactions(paymentKeys, pageNo, blockHeight, currency) {
    return __awaiter(this, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, network_1["default"])({
                        method: "POST",
                        url: (0, logic_1.isTestnet)(currency)
                            ? "".concat(constants_1.CARDANO_TESTNET_API_ENDPOINT, "/v1/transaction")
                            : "".concat(constants_1.CARDANO_API_ENDPOINT, "/v1/transaction"),
                        data: {
                            paymentKeys: paymentKeys,
                            pageNo: pageNo,
                            blockHeight: blockHeight
                        }
                    })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res.data];
            }
        });
    });
}
function getAllTransactionsByKeys(paymentKeys, blockHeight, currency) {
    return __awaiter(this, void 0, void 0, function () {
        var transactions, latestBlockHeight, isAllTrxFetched, pageNo, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    transactions = [];
                    latestBlockHeight = 0;
                    isAllTrxFetched = false;
                    pageNo = 1;
                    _a.label = 1;
                case 1:
                    if (!!isAllTrxFetched) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchTransactions(paymentKeys, pageNo, blockHeight, currency)];
                case 2:
                    res = _a.sent();
                    transactions.push.apply(transactions, __spreadArray([], __read(res.transactions), false));
                    latestBlockHeight = Math.max(res.blockHeight, latestBlockHeight);
                    isAllTrxFetched = res.transactions.length < res.limit;
                    pageNo += 1;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, {
                        transactions: transactions,
                        blockHeight: latestBlockHeight
                    }];
            }
        });
    });
}
function getSyncedTransactionsByChain(accountPubKey, accountIndex, chainType, blockHeight, initialPaymentCredentials, currency) {
    return __awaiter(this, void 0, void 0, function () {
        var keyChainRange, initialPaymentCredentialMap, maxUsedKeyIndex, transactions, latestBlockHeight, trxsRes, newPaymentCredentialsMap, lastSyncedKeyIndex, syncToKeyIndex, _loop_1, availablePaymentCredentialsMap;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    keyChainRange = (0, env_1.getEnv)("KEYCHAIN_OBSERVABLE_RANGE") || 20;
                    initialPaymentCredentialMap = {};
                    maxUsedKeyIndex = -1;
                    initialPaymentCredentials.forEach(function (cred) {
                        initialPaymentCredentialMap[cred.key] = cred;
                        if (cred.isUsed)
                            maxUsedKeyIndex = cred.path.index;
                    });
                    transactions = [];
                    latestBlockHeight = 0;
                    return [4 /*yield*/, Promise.all((0, chunk_1["default"])(Object.keys(initialPaymentCredentialMap), keyChainRange).map(function (keys) {
                            return getAllTransactionsByKeys(keys, blockHeight, currency);
                        }))];
                case 1:
                    trxsRes = _a.sent();
                    trxsRes.forEach(function (txRes) {
                        transactions.push.apply(transactions, __spreadArray([], __read(txRes.transactions), false));
                        latestBlockHeight = Math.max(latestBlockHeight, txRes.blockHeight);
                    });
                    newPaymentCredentialsMap = {};
                    lastSyncedKeyIndex = initialPaymentCredentials.length
                        ? initialPaymentCredentials[initialPaymentCredentials.length - 1].path.index
                        : -1;
                    syncToKeyIndex = maxUsedKeyIndex + keyChainRange;
                    _loop_1 = function () {
                        var currentPaymentKeysMap, trxRes;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    currentPaymentKeysMap = {};
                                    (0, range_1["default"])(lastSyncedKeyIndex + 1, syncToKeyIndex + 1, 1).forEach(function (keyIndex) {
                                        var keyPath = (0, logic_1.getCredentialKey)(accountPubKey, (0, logic_1.getBipPath)({
                                            account: accountIndex,
                                            chain: chainType,
                                            index: keyIndex
                                        }));
                                        currentPaymentKeysMap[keyPath.key] = {
                                            isUsed: false,
                                            key: keyPath.key,
                                            path: keyPath.path
                                        };
                                    });
                                    return [4 /*yield*/, getAllTransactionsByKeys(Object.keys(currentPaymentKeysMap), blockHeight, currency)];
                                case 1:
                                    trxRes = _b.sent();
                                    transactions.push.apply(transactions, __spreadArray([], __read(trxRes.transactions), false));
                                    lastSyncedKeyIndex = syncToKeyIndex;
                                    latestBlockHeight = Math.max(latestBlockHeight, trxRes.blockHeight);
                                    newPaymentCredentialsMap = Object.assign({}, newPaymentCredentialsMap, currentPaymentKeysMap);
                                    maxUsedKeyIndex = trxRes.transactions.reduce(function (maxIndexA, _a) {
                                        var inputs = _a.inputs, outputs = _a.outputs;
                                        return __spreadArray(__spreadArray([], __read(inputs), false), __read(outputs), false).reduce(function (maxIndexB, io) {
                                            var _a;
                                            return Math.max(((_a = newPaymentCredentialsMap[io.paymentKey]) === null || _a === void 0 ? void 0 : _a.path.index) || -1, maxIndexB);
                                        }, maxIndexA);
                                    }, maxUsedKeyIndex);
                                    syncToKeyIndex = maxUsedKeyIndex + keyChainRange;
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _a.label = 2;
                case 2:
                    if (!(syncToKeyIndex !== lastSyncedKeyIndex)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1()];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 2];
                case 4:
                    availablePaymentCredentialsMap = __assign(__assign({}, initialPaymentCredentialMap), newPaymentCredentialsMap);
                    transactions.forEach(function (trx) {
                        __spreadArray(__spreadArray([], __read(trx.inputs), false), __read(trx.outputs), false).forEach(function (io) {
                            if (availablePaymentCredentialsMap[io.paymentKey]) {
                                availablePaymentCredentialsMap[io.paymentKey].isUsed = true;
                            }
                        });
                    });
                    return [2 /*return*/, {
                            transactions: transactions,
                            latestBlockHeight: latestBlockHeight,
                            paymentCredentials: Object.values(availablePaymentCredentialsMap).sort(function (aCred, bCred) { return aCred.path.index - bCred.path.index; })
                        }];
            }
        });
    });
}
function getTransactions(xpub, accountIndex, initialAccount, blockHeight, currency) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var accountPubKey, oldExternalCredentials, oldInternalCredentials, _c, _d, externalKeyTransactions, aBlockHeight, externalCredentials, _e, internalKeyTransactions, bBlockHeight, internalCredentials;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    accountPubKey = (0, logic_1.getExtendedPublicKeyFromHex)(xpub);
                    oldExternalCredentials = ((_a = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.cardanoResources) === null || _a === void 0 ? void 0 : _a.externalCredentials) || [];
                    oldInternalCredentials = ((_b = initialAccount === null || initialAccount === void 0 ? void 0 : initialAccount.cardanoResources) === null || _b === void 0 ? void 0 : _b.internalCredentials) || [];
                    return [4 /*yield*/, Promise.all([
                            getSyncedTransactionsByChain(accountPubKey, accountIndex, types_1.PaymentChain.external, blockHeight, oldExternalCredentials, currency),
                            getSyncedTransactionsByChain(accountPubKey, accountIndex, types_1.PaymentChain.internal, blockHeight, oldInternalCredentials, currency),
                        ])];
                case 1:
                    _c = __read.apply(void 0, [_f.sent(), 2]), _d = _c[0], externalKeyTransactions = _d.transactions, aBlockHeight = _d.latestBlockHeight, externalCredentials = _d.paymentCredentials, _e = _c[1], internalKeyTransactions = _e.transactions, bBlockHeight = _e.latestBlockHeight, internalCredentials = _e.paymentCredentials;
                    return [2 /*return*/, {
                            transactions: __spreadArray(__spreadArray([], __read(externalKeyTransactions), false), __read(internalKeyTransactions), false),
                            blockHeight: Math.max(aBlockHeight, bBlockHeight),
                            externalCredentials: externalCredentials,
                            internalCredentials: internalCredentials
                        }];
            }
        });
    });
}
exports.getTransactions = getTransactions;
//# sourceMappingURL=getTransactions.js.map